export default __webpack_public_path__ + "static/media/6.e7f3735d.jpg";